import { types } from 'mobx-state-tree';
import type { Instance } from 'mobx-state-tree';

const ExtraDownloads = types.model('ExtraDownloads', {
    downloadName: types.maybeNull(types.string),
    downloadUrl: types.maybeNull(types.string),
});

const CtaModel = types.model('CtaModel', {
    decoratorIcon: types.maybeNull(types.string),
    label: types.maybeNull(types.string),
    url: types.maybeNull(types.string),
    target: types.maybeNull(types.string),
    variant: types.enumeration('variant', ['contained', 'outlined', 'text']),
});
export type TypeCtaModel = Instance<typeof CtaModel>;

const WwiseCertificationModel = types.model('WwiseCertificationModel', {
    examUrl: types.maybeNull(types.string),
    renewUrl: types.maybeNull(types.string),
    storeUrl: types.maybeNull(types.string),
    certUrl: types.maybeNull(types.string),
    certifiedUserLogoUrl: types.maybeNull(types.string),
    ctas: types.array(CtaModel),
    helperText: types.maybeNull(types.string),
    description: types.maybeNull(types.string),
    logoUrl: types.maybeNull(types.string),
    name: types.maybeNull(types.string),
    publicId: types.maybeNull(types.string),
    status: types.maybeNull(types.string),
    dateCertified: types.maybeNull(types.string),
    expiryDate: types.maybeNull(types.string),
    certPDFUrl: types.maybeNull(types.string),
    logoKitUrl: types.maybeNull(types.string),
    extraDownloads: types.array(ExtraDownloads),
});

export type TypeWwiseCertificationModel = Partial<Instance<typeof WwiseCertificationModel>>;
export default WwiseCertificationModel;
